export default __webpack_public_path__ + "static/onlinejobsph-21f4cd402898d2274bccbef3bcb0c558.png";